import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService, httpHeaders } from '../../client.service';

import {
  EventHistoryApiModel,
  EventHistoryVersion,
  EventsData,
  EventsHistoryQueryParams,
} from './events-history.model';
import { GetResponse } from '@vi-iot/client/models';

@Injectable()
export class EventsHistoryApi implements EventHistoryApiModel {
  constructor(private clientService: ClientService) {}

  /**
   * Returns list of events for Event Log
   * @param installationId
   * @param params
   * @param version
   */
  getEvents(
    installationId: string,
    params: EventsHistoryQueryParams,
    version: EventHistoryVersion = 'v2'
  ): Observable<EventsData> {
    const endpoint = `iot/${version}/events-history/installations/${installationId}/events`;

    return this.clientService.get(endpoint, params, httpHeaders);
  }

  triggerEventLogFileGeneration(installationId: number): Observable<GetResponse<string>> {
    const url = `iot/v2/events-history/installations/${installationId}/export`;
    return this.clientService.post(url, {});
  }

  downloadEventLogFile(installationId: number, processId: string): Observable<{ data: string }> {
    const url = `iot/v2/events-history/installations/${installationId}/export/${processId}`;
    return this.clientService.get(url, {});
  }
}
